import { Box, ListItem, Text, UnorderedList } from "@chakra-ui/react";
import { TEXT_VARIANTS } from "@/theme/components/text";

export type SimpleListProps = {
  points: string[];
};

const SimpleList = ({ points }: SimpleListProps) => {
  return (
    <Box>
      <UnorderedList>
        {points.map((point, index) => {
          return (
            <ListItem color={"text.100"} key={index}>
              <Text variant={TEXT_VARIANTS.BODY2}>{point}</Text>
            </ListItem>
          );
        })}
      </UnorderedList>
    </Box>
  );
};

export default SimpleList;
